


import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { SingleButton } from "./models";


// Buttons
const getAllButtonsAdmin = async (): Promise<SingleButton[]> => {
    let config = getConfig();
    try {
        const response = await axios.get<SingleButton[]>(`/admin/getButtonsAdmin`, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
};


const getButtonById = async (id: string): Promise<SingleButton> => {
    let config = getConfig();
    try {
        const response = await axios.get<SingleButton>(`/admin/getButtonAdmin?id=${id}`, config);
        return response.data;
    } catch (error) {
        return error as any;
    }

}

const createButton = async ({ category, messages, name }: { category: string, messages: string[], name: string }): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.post<SingleButton>(`/admin/createButton`, { category, messages, name }, config);
        return response.data;
    } catch (error) {
        return error as any;
    }

}

const deleteButton = async ({ buttonId }: { buttonId: string }): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.post<SingleButton>(`/admin/deleteButton`, { buttonId }, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
}

const editButton = async ({ buttonId, name, category }: { buttonId: string, name: string, category: string }): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.post<SingleButton>(`/admin/editButton`, { buttonId, name, category }, config);

        return response.data;
    } catch (error) {
        return error as any;
    }
}


// Variants
const updateVariant = async ({ messageId, text }: { messageId: string, text: string }): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.post<SingleButton>(`/admin/editMessage`, { messageId, text }, config);

        return response.data;
    } catch (error) {
        return error as any;
    }

}


const createVariant = async ({ buttonId, text }: { buttonId: string, text: string }): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.post<SingleButton>(`/admin/createVariant`, { buttonId, text }, config);
        return response.data;
    } catch (error) {
        return error as any;
    }

}

const deleteVariant = async ({ messageId }: { messageId: string }): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.post<SingleButton>(`/admin/deleteMessage`, { messageId }, config);

        return response.data;
    } catch (error) {
        return error as any;
    }
}

const createBulkVariants = async ({ buttonId, variants }: { buttonId: string, variants: string[] }): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.post<SingleButton>(`/admin/createBulkVariants`, { buttonId, variants }, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
}

const removeAllVariants = async ({ buttonId }: { buttonId: string }): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.post(`/admin/removeAllVariants`, { buttonId }, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
}




export {
    getAllButtonsAdmin,
    getButtonById,
    updateVariant,
    createVariant,
    createButton,
    deleteVariant,
    deleteButton,
    editButton,
    createBulkVariants,
    removeAllVariants

}